import type { MaterialNames } from "@/components/material_symbol_names";

const ICON_BY_AREA: Record<string, MaterialNames> = {
  Home: "home",
  People: "group",
  Sections: "domain",
  Facilities: "store",
  Billing: "card_membership",
  Education: "school",
  Activities: "today",
  Events: "today",
  Jobs: "business_center",
  Photobooth: "photo_camera",
  Tasks: "task_alt",
  "Search Results": "search",
  "System Preferences": "settings",
  "Member 360 Configuration": "tune",
  "MCP Playground": "smart_toy",
  "Chat Logs": "forum"
};

export function globalSearchIconName(destination: { label: string; breadcrumbs: string[] }): MaterialNames {
  const area = destination.breadcrumbs[0] ?? destination.label;
  return ICON_BY_AREA[area] ?? "description";
}
